<template>
  <div class="model-frame">
    <el-row>
      <div class="model-header">
        <h2>Lịch sử thanh toán</h2>
        <div>
          <!-- <el-button @click="createModelSalary" size="small" type="info" class="btn-create">Thanh toán Lương</el-button> -->
          <!-- <el-button @click="createModel" size="small" type="info" class="btn-create">Thêm mới</el-button> -->
        </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-filter">
        <el-col :span="4">
          <el-select v-model="filter.status" filterable clearable placeholder="Trạng thái" class="input-select">
            <el-option
              v-for="item in lists.listStatus"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="6">
          <el-select v-model="filter.type" filterable clearable placeholder="Hình thức" class="input-select">
            <el-option
              v-for="item in lists.listType"
              :key="item.key"
              :label="item.value"
              :value="item.key">
            </el-option>
          </el-select>
        </el-col>
        <el-col :span="2">
          <el-popover
            placement="bottom"
            title="Sắp xếp theo"
            width="400"
            trigger="click"
            content="Nội dung">
            <div class="model-filter-radio"
              v-for="(item, index) in sort"
              :key="index">
              <span>{{ item.groupName }}:</span>
              <el-radio
                v-for="(itemSort, index_itemSort) in item.groupFiled"
                :key="index_itemSort"
                v-model="filter.sort" :label="itemSort.label">{{ itemSort.text }}</el-radio>
            </div>
            <span class="model-filter-search" slot="reference">
              <i class="fas fa-sort"></i>
            </span>
          </el-popover>
        </el-col>
        <el-col :span="6"></el-col>
        <el-col :span="5">
          <el-input
            placeholder="Tìm kiếm ..."
            class="input-seach"
            clearable
            :prefix-icon="searching ? 'fas fa-spinner fa-spin' : 'el-icon-search'"
            v-model="filter.q">
          </el-input>
        </el-col>
      </div>
    </el-row>
    <el-row>
      <div class="model-pagination">
          <el-pagination
            background
            layout="prev, pager, next"
            :page-size="table.pagination.per_page"
            :pager-count="table.pagination.count"
            :current-page="table.pagination.current_page"
            :total="table.pagination.total"
            @current-change="changeCurrentPage">
          </el-pagination>
          <div>
            Hiển thị tới lịch sử <strong>{{ table.meta_pagination }}</strong> / Tổng số: <strong>{{ table.pagination.total }}</strong> lịch sử
          </div>
      </div>
    </el-row>
    <el-row>
      <div class="model-table">
        <el-table
          v-loading="loading"
          border
          :data="table.database"
          style="width: 100%">
          <el-table-column
            label="#"
            type="index"
            width="40">
          </el-table-column>
          <el-table-column
            width="200"
            label="Tài khoản được hưởng">
            <template slot-scope="scope">
              <div class="courses-info">
                <span style="font-weight: bold">{{ scope.row.user_txt }}</span>
                <span>{{ scope.row.user_email }}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            align="right"
            header-align="right"
            label="Số tiền">
            <template slot-scope="scope">
              <div class="courses-info">
                <span v-if="scope.row.money > 0 && scope.row.status == 1" style="font-weight: bold; color: green">{{ scope.row.money | vnd}}</span>
                <span v-if="scope.row.money > 0 && scope.row.status != 1" style="font-weight: bold">{{ scope.row.money | vnd}}</span>
                <span v-if="scope.row.money < 0" style="font-weight: bold; color: red">{{ scope.row.money | vnd}}</span>
              </div>
            </template>
          </el-table-column>
          <el-table-column
            width="200"
            label="Hình thức">
            <template slot-scope="scope">
                <span>{{ scope.row.type_txt }}</span>
            </template>
          </el-table-column>
          <el-table-column
            label="Ghi chú">
            <template slot-scope="scope">
                <span>{{ scope.row.note }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="170"
            label="Thời gian">
            <template slot-scope="scope">
                <span>{{ scope.row.created_at }}</span>
                <p v-if="scope.row.type == 3">Cập nhật: {{ scope.row.updated_at }}</p>
            </template>
          </el-table-column>
          <el-table-column
            width="120"
            label="Trạng thái">
            <template slot-scope="scope">
                <span>{{ scope.row.status_txt }}</span>
            </template>
          </el-table-column>
          <el-table-column
            width="50"
            label=""
            header-align="center">
            <template slot-scope="scope">
              <div class="module-action">
                <el-tooltip v-if="scope.row.type === 1" effect="dark" content="Xóa" placement="top">
                  <span @click="confirmDeleteModel(scope.row)">
                    <i class="far fa-trash-alt icon-delete"></i>
                  </span>
                </el-tooltip>
                <el-tooltip v-if="scope.row.type === 3 && scope.row.status === 0" effect="dark" content="Xác nhận Nạp tiền" placement="top">
                  <span @click="adminConfirmBankType3(scope.row)">
                    <i class="fas fa-dollar-sign"></i>
                  </span>
                </el-tooltip>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </el-row>
  </div>
</template>

<script>
import axios from 'axios'
import { head, findIndex } from 'lodash'
import { mapActions } from 'vuex'
export default {
  name: 'Payments',
  metaInfo () {
    return {
      title: 'Lịch sử thanh toán'
    }
  },
  data () {
    return {
      loading: false,
      searching: false,
      filter: {
        q: '',
        status: '',
        type: '',
        daterange: '',
        page: 1,
        limit: 15,
        sorted: '',
        include: ''
      },
      sort: [
        {
          groupName: 'Không sắp xếp',
          groupFiled: [
            { label: '', text: 'Không sắp xếp' }
          ]
        },
        {
          groupName: 'Thời gian',
          groupFiled: [
            { label: 'created_at:-1', text: 'Tăng dần' },
            { label: 'created_at:1', text: 'Giảm dần' }
          ]
        }
      ],
      lists: {
        listStatus: [
          {key: 0, value: 'Đang xử lý'},
          {key: 1, value: 'Thành công'},
          {key: 2, value: 'Hủy'}
        ],
        listType: [
          {key: 1, value: 'Admin nạp'},
          {key: 3, value: 'Nạp tiền qua chuyển khoản'},
          {key: 4, value: 'Nạp tiền qua Ngân Lượng'},
          {key: 2, value: 'Mua khóa học'}
        ]
      },
      table: {
        database: [],
        meta_pagination: 0,
        pagination: {
          total: 0,
          count: 0,
          per_page: 0,
          current_page: 1,
          total_pages: 0
        },
        timer: {}
      }
    }
  },
  mounted () {
    this.configBreadcrumb()
    this.fetchDatabaseModel()
  },
  methods: {
    ...mapActions(['setBreadcrumb']),
    // Cấu hình Breadcrumb
    configBreadcrumb () {
      let breadcrumb = [
        { name: 'home-index', text: 'Trang chủ' },
        { name: 'payments-index', text: 'Lịch sử thanh toán' }
      ]
      this.setBreadcrumb(breadcrumb)
    },
    adminConfirmBankType3 (item) {
      this.$confirm('Xác nhận số tiền ' + item.money_format + 'đ cho tài khoản ' + item.user_email, 'Xác nhận tiền nạp của ' + item.user_txt, {
        confirmButtonText: 'OK',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.adminConfirmBankType3Api(item)
      }).catch(() => {
        this.$message({
          type: 'info',
          message: 'Hủy xác nhận nạp tiên'
        })
      })
    },
    adminConfirmBankType3Api (item) {
      this.canSubmit = false
      axios.post('payments/admin-confirm-bank-type-3/' + item.id).then(response => {
        this.canSubmit = true
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Nạp thành công',
              type: 'success'
            })
            item.status = 1
            item.status_txt = 'Thành công'
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Nút tạo Model
    createModel () {
      this.$router.push({name: 'payments-create'})
    },
    createModelSalary () {
      this.$router.push({name: 'payments-create-salary'})
    },
    // Fetch dữ liệu
    fetchDatabaseModel () {
      this.loading = true
      axios.get('payments', {params: this.filter}).then(response => {
        this.loading = false
        switch (response.code) {
          case 200:
            this.table.database = response.data
            this.table.pagination = response.meta.pagination
            this.caculaterMetaPagination()
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xẳy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tính trường số bản ghi xem nó đang hiện đến bao nhiêu
    caculaterMetaPagination () {
      if (this.table.pagination.current_page === this.table.pagination.total_pages) {
        this.table.meta_pagination = (this.table.pagination.current_page - 1) * this.table.pagination.per_page + this.table.pagination.count
      } else {
        this.table.meta_pagination = this.table.pagination.current_page * this.table.pagination.per_page
      }
    },
    // Xem chi tiết
    showModel (model) {
      this.$router.push({name: 'payments-show', params: {course_id: model.id}})
    },
    updateModel (model) {
      this.$router.push({name: 'payments-update', params: {course_id: model.id}})
    },
    // Đổi trạng thái kích hoạt / không kích hoạt
    changeStatus (model) {
      let dataUpdate = {
        'status': model.status
      }
      axios.post('payments/update-status/' + model.id, dataUpdate).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Cập nhật trạng thái thành công',
              type: 'success',
              duration: '2000'
            })
            model.status_txt = model.status ? 'Kích hoạt' : 'Chưa kích hoạt'
            break
          default:
            this.fetchDatabaseModel()
            break
        }
      })
    },
    // confirmDeleteModel
    confirmDeleteModel (model) {
      this.$confirm('Xác nhận xóa lịch sử nạp ' + model.money_format + ' của : ' + model.user_txt, 'Warning', {
        confirmButtonText: 'Đồng ý',
        cancelButtonText: 'Hủy',
        type: 'warning'
      }).then(() => {
        this.deleteModel(model)
      }).catch(() => {

      })
    },
    // Xóa bản ghi
    deleteModel (model) {
      axios.delete('payments/' + model.id).then(response => {
        switch (response.code) {
          case 200:
            this.$notify({
              title: 'Thành công',
              message: 'Xóa bản ghi thành công',
              type: 'success'
            })
            let indexDelete = this.findIDLocal(model)
            if (indexDelete > -1) {
              this.table.database.splice(indexDelete, 1)
            }
            break
          case 404:
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: 'Không tìm thấy tài nguyên',
              type: 'warning'
            })
            break
          case 422:
            let er = response.data.errors
            let message = head(er[Object.keys(er)[0]])
            this.$notify({
              title: 'Có lỗi xảy ra',
              message: message,
              type: 'warning'
            })
            break
          default:
            this.$notify.error({
              title: 'Error',
              message: 'Đã có lỗi xảy ra. Vui lòng liên hệ Admin !'
            })
            break
        }
      })
    },
    // Tìm ID ở database Local để xóa đi
    findIDLocal (model) {
      let index = findIndex(this.table.database, function (o) {
        return o.id === model.id
      })
      return index
    },
    // Thay đổi Current Page
    changeCurrentPage (currentPage) {
      this.filter.page = currentPage
      this.fetchDatabaseModel()
    }
  },
  watch: {
    'filter.q': function () {
      this.searching = true
      clearTimeout(this.timer)
      let _this = this
      this.timer = setTimeout(function () {
        _this.searching = false
        _this.fetchDatabaseModel()
      }, 800)
    },
    'filter.sort': function () {
      this.fetchDatabaseModel()
    },
    'filter.status': function () {
      this.fetchDatabaseModel()
    },
    'filter.type': function () {
      this.fetchDatabaseModel()
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.model-filter-search {
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #efefef;
  border-radius: 2px;
  width: 30px;
  height: 30px;
  cursor: pointer;
}
.model-filter-radio {
  margin-bottom: 10px;
}
.model-filter-radio span {
  margin-right: 20px;
  width: 135px;
  display: inline-block;
}
.course-image {
  width: 150px;
  border-radius: 2px;
}
.courses-info {
  display: flex;
  flex-direction: column;
}
.courses-info span {
  margin-bottom: 5px;
}
</style>



// WEBPACK FOOTER //
// src/components/payments/Index.vue